import React from 'react';

import { useUserContext } from '../../../common/utils/context';
import { getLocalTime } from '../../../common/utils/time/time';
import StatusBadge from '../../design/components/StatusBadge';
import { useDriverDay } from './DriverDayProvider';

/**
 * "Clocked in 6:48 am" header badge for the driver phase screens (pass it as
 * Screen `headerRight`). Shows the clock of the driver whose day is open (the
 * trainee in training mode); nothing when clocked out or not clocked in.
 */
const DriverClockBadge = () => {
	const { tenant } = useUserContext();
	const { clockStatus } = useDriverDay();
	if (!clockStatus?.isClockedIn) {
		return null;
	}

	const since = clockStatus.lastEventCapturedAt
		? getLocalTime(tenant?.timezone, clockStatus.lastEventCapturedAt).format('h:mm a')
		: null;
	return <StatusBadge tone="success" label={since ? `Clocked in ${since}` : 'Clocked in'} />;
};

export default DriverClockBadge;
